import { characters } from '@/mocks/comic';

export default function Characters() {
  return (
    <section id="characters" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <span className="h-px w-8 bg-primary-500" />
              角色档案
            </span>
            <h2 className="mt-4 font-heading text-3xl font-black text-foreground-900 md:text-4xl">
              主要角色设定全收录
            </h2>
            <p className="mt-3 max-w-2xl text-base text-foreground-700">
              每个角色的性格、立场与成长轨迹都整理成档，方便追更时随时对照。
            </p>
          </div>
          <a
            href="#analysis"
            className="inline-flex items-center gap-2 rounded-full bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 whitespace-nowrap ring-1 ring-background-300/70 transition-colors hover:bg-background-200/60"
          >
            看角色专题
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {characters.map((c) => (
            <article
              key={c.id}
              className="group overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200/70 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.name}·${c.role}角色设定图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/60 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  {c.role}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-xl font-bold text-foreground-900">{c.name}</h3>
                <div className="mt-2 flex flex-wrap gap-2">
                  {c.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-full bg-accent-100 px-3 py-0.5 text-xs font-medium text-accent-900 whitespace-nowrap"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}